import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Body1 } from '@/components/@IntranetLibrary/Typography';
import { CreateTitle } from './styles';
import type { ApprovalCreateMode, ApprovalFormValues } from './types';

type CreateHeaderProps = {
  /** 품의 양식 이름 (예: "기본품의"). 양식 응답 도착 전에는 undefined */
  approvalTypeName?: string;
  /** 'create' 신규 작성 / 'edit' 기존 문서 편집 */
  mode: ApprovalCreateMode;
  /** 문서번호를 제목 아래 줄에 좌측 정렬 (모바일 헤더용). 미지정 시 제목 우측 정렬 */
  stackDocId?: boolean;
};

const CreateHeader = ({
  approvalTypeName,
  mode,
  stackDocId,
}: CreateHeaderProps) => {
  const { t } = useTranslation();
  const { getValues } = useFormContext<ApprovalFormValues>();
  const docId = getValues('docId');

  const suffix = mode === 'edit' ? t('수정중') : t('신규 작성');
  const title = approvalTypeName
    ? `${approvalTypeName} ${suffix}`
    : `${t('품의')} ${suffix}`;

  return (
    <CreateTitle variant="h6">
      {title}
      <Body1
        component="span"
        sx={{
          ...(stackDocId ? { display: 'block' } : { float: 'right' }),
          mt: 1,
          fontWeight: 400,
          color: 'text.secondary',
        }}
      >
        {`Document No : ${docId || '-'}`}
      </Body1>
    </CreateTitle>
  );
};

export default CreateHeader;
